module.exports = __webpack_public_path__ + "img/IMG_3945_L_Black_MockedUp.b22965e9.jpg";